<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-6 py-1 px-2" dense height="30">
      <v-toolbar-title class="mt-4 me-4">{{
        titleProp ? $t(titleProp) : $t($route.name)
      }}</v-toolbar-title>
      <div v-if="!isMobile && !isTablet && !mobileShow" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile && type !== 'removedChecks' && !mobileShow"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important; padding: 0 !important"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            link
            v-show="type === 'removedChecks'"
            :disabled="!selected || (selected && selected.length === 0) ? true : false"
            @click="refreshRemovedItem"
          >
            <v-list-item-icon>
              <v-icon>mdi-delete-restore</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refreshRemovedChecks')" />
          </v-list-item>
          <v-list-item
            link
            v-if="lockPermission && selected.length > 0"
            :disabled="!selected || (selected && selected.length === 0) ? true : false"
            @click="lockGroup('lock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('lock')" />
          </v-list-item>
          <v-list-item
            v-if="lockPermission && selected.length > 0"
            link
            @click="unlockGroup('unlock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-open-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('unlock')" />
          </v-list-item>
          <v-list-item v-show="type === 'recieveCheck'" link @click="openUploadDialog">
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item v-if="isMobile || isTablet || mobileShow" link @click="getItems">
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet || mobileShow"
            link
            @getAllRows="getAllRows"
          >
            <export-excel
              ref="refExcel"
              :data="excelItems"
              worksheet="abriron.com"
              name="data.xls"
              type="xls"
              class="float-left d-flex"
              :title="$store.state.abrName"
              :total-prop="pageCount"
              :page-prop="excelPage"
              @getAllRows="getAllRows"
            >
              <v-list-item-icon>
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('excel')" />
            </export-excel>
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet || mobileShow"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet || mobileShow" link @click="goTo(type)">
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t(type)" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet && !mobileShow"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        @click="goTo(type)"
        @shortkey="goTo(type)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(type) }}
        </p>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col class="mb-4 px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col v-if="mobileShow" class="py-0 pt-3 px-2" cols="12">
        <v-chip-group v-model="type" mandatory active-class="primary--text">
          <v-chip small dark label value="payCheck">
            {{ $t("payCheckList") }}
          </v-chip>
          <v-chip small label value="recieveCheck">
            {{ $t("recieveCheckList") }}
          </v-chip>
        </v-chip-group>
      </v-col>
      <v-col v-show="!isMobile" class="px-1 py-0" cols="12" md="12">
        <div class="d-flex align-center justify-space-between gap-2">
          <v-chip-group
            mandatory
            active-class="primary--text"
            class="justify-start"
            style="padding-top: 1px"
          >
            <v-chip label outlined>
              {{ $t("totalSum") }} : {{ $numberFormat(summary ? summary.amount : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
          </v-chip-group>
          <v-btn
            color="secondary"
            outlined
            height="32"
            class="ml-2"
            :loading="loading"
            @click="fetchCheckAverageFirst"
          >
            <span class="ml-2">
              {{ selectedCheck.length != 0 ? "(" + selectedCheck.length + ")" : "" }}
              {{ $t("checks-count") }}
            </span>
            <my-icon
              :name="'check-average'"
              :width="18"
              :height="19"
              :cursor-pointer="true"
            />
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-col cols="12" class="px-2">
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="isMobile || isTablet || mobileShow ? 323 : tableHeight"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :hide-default-header="isMobile || mobileShow"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3; border-radius: 6px"
        :page.sync="page"
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-if="isMobile || mobileShow" v-slot:item="{ item, index }">
          <tr :class="{ 'mobile-show': mobileShow }">
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0"
                :class="{
                  'mobile-td-list-border-red': item.type == 'own' ? true : false,
                  'mobile-td-list-border-green': item.type == 'customer' ? true : false,
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          v-if="
                            (item.status && item.status.status == 'issued') ||
                            (item.status && item.status.status == 'fund')
                          "
                          link
                          :disabled="item.lock ? true : false"
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          v-show="item.kind !== 'guarantee'"
                          link
                          @click="openCheckStatusDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-qrcode-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('change') + ' ' + $t('status')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="
                            $baseURL +
                            '/' +
                            (item.type == 'own' ? 'check/pay' : 'check/recieve') +
                            '/edit/' +
                            item.id
                          "
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <v-list-item link @click="documentPrint(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-printer-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            v-text="$t('print') + ' ' + $t('document')"
                          />
                        </v-list-item>
                        <log
                          :title-prop="$t('history')"
                          icon-prop="mdi-history"
                          :listProp="true"
                          :type-prop="typeForm"
                          :refIdProp="item.id"
                          mode-prop="button"
                        />
                        <v-list-item
                          v-if="
                            ((item.status && item.status.status == 'issued') ||
                              (item.status && item.status.status == 'fund')) &&
                            removePermission(type)
                          "
                          link
                          :disabled="item.lock ? true : false"
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content class="pb-0">
                  <v-list-item-title class="text-wrap">
                    {{ item.account ? item.account.name : "" }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("bank") }} : {{ item.bank ? item.bank.name : "" }} |
                    {{ $t("number") }} {{ $t("check") }}: {{ item.number }} |
                    {{ $t("id") }} : {{ item.id }} | {{ $t("date") }} : {{ item.date }} |
                    {{ $t("due") }} : {{ item.due_date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <v-chip
                      v-if="item.status && item.status.status"
                      :color="item.status.color"
                      label
                      small
                      style="cursor: pointer"
                      class="px-1"
                      @click="openCheckStatusDialog(item)"
                    >
                      <span class="px-2 white--text">
                        {{ $t(item.status.status) }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.payed_account_id && item.type == 'customer'"
                      color="primary"
                      label
                      small
                      style="cursor: pointer"
                      class="px-1 ma-1"
                    >
                      <span class="px-2 white--text">
                        {{ $t("to") }}
                        {{
                          item.payed_account ? $t(item.payed_account.name) : $t("haveNot")
                        }}
                        - {{ $t("date") }}:{{ item.payed_date }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="type == 'payCheck' && item.type == 'customer'"
                      color="teal"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ $t("recieveCheck") }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.initial_period"
                      color="primary"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ $t("initialPeriod") }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.status && item.status.bank"
                      color="green"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ item.status.bank.name }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.status && item.status.bank"
                      color="orange"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ $t("lastChangeStatus") }} : {{ item.status.time }}
                      </span>
                    </v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <v-chip
                      v-for="(relation, index) in item.relations"
                      :key="index"
                      :color="relation.color"
                      label
                      outlined
                      small
                      style="margin-left: 1px; margin-right: 1px"
                      class="px-1 mb-1"
                      @click="edit(item)"
                    >
                      {{ relation.name }}
                    </v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.tags" class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn dark text small color="primary" @click="edit(item)">
                    {{ $numberFormat(item.amount) }} {{ item.currency.name }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                v-if="
                  (type !== 'removedChecks' &&
                    item.status &&
                    item.status.status == 'issued') ||
                  (item.status && item.status.status == 'fund')
                "
                link
                :disabled="item.lock ? true : false"
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="type !== 'removedChecks' && lockPermission"
                link
                @click="lock(item, item.lock ? 'unlock' : 'lock')"
              >
                <v-list-item-icon>
                  <v-icon :color="item.lock ? 'green' : 'pink'">
                    {{ item.lock ? "mdi-lock-open-outline" : "mdi-lock-outline" }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.lock ? $t('unlock') : $t('lock')" />
              </v-list-item>
              <v-list-item
                v-show="type !== 'removedChecks' && item.kind !== 'guarantee'"
                link
                @click="openCheckStatusDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-qrcode-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('change') + ' ' + $t('status')" />
              </v-list-item>
              <v-list-item
                v-if="type !== 'removedChecks'"
                v-clipboard:copy="
                  $baseURL +
                  '/' +
                  (item.type == 'own' ? 'check/pay' : 'check/recieve') +
                  '/edit/' +
                  item.id
                "
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item
                v-if="type !== 'removedChecks'"
                link
                @click="documentPrint(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print') + ' ' + $t('document')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-if="
                  ((item.status && item.status.status == 'issued') ||
                    (item.status && item.status.status == 'fund')) &&
                  removePermission(type)
                "
                link
                :disabled="item.lock ? true : false"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          <a
            @click="
              (item.status && item.status.status == 'issued') ||
              (item.status && item.status.status == 'fund')
                ? edit(item)
                : null
            "
          >
            {{ item.id }}
          </a>
          <v-icon v-if="item.lock" color="red" style="font-size: 22px">
            mdi-lock-outline
          </v-icon>
          <v-chip
            v-if="type === 'removedChecks'"
            :color="item.type === 'own' ? 'blue' : 'green'"
            label
            small
            style="margin-left: 1px; margin-right: 1px"
            class="px-1 mb-1"
          >
            <span class="px-1 white--text"> {{ $t("check") }} {{ $t(item.type) }} </span>
          </v-chip>
        </template>
        <template v-slot:item.doc_header.number="{ item }">
          <a v-if="item.doc_header" @click="documentPrint(item)">
            {{
              item.payedDocumentNumber ? item.payedDocumentNumber : item.doc_header.number
            }}
          </a>
        </template>
        <template v-slot:item.account.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('account', item.account.id)"
            >
              {{ item.account.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.account.fin_id)"
                >
                  <v-icon color="teal" style="font-size: 22px">
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("turnover") }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.row="{ item }">
          <a
            @click="
              (item.status && item.status.status == 'issued') ||
              (item.status && item.status.status == 'fund')
                ? edit(item)
                : null
            "
          >
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.amount="{ item }">
          {{ item.amount ? $numberFormat(item.amount, item.currency.decimal) : 0 }}
          {{
            item.amount && $store.state.currency.id !== item.currency.id
              ? "(" + item.currency.symbol + ")"
              : ""
          }}
        </template>
        <template v-slot:item.currency="{ item }">
          {{ item.currency.name }}
        </template>
        <template v-slot:item.bank="{ item }">
          {{
            item.type === "own"
              ? item.bank.number
                ? item.bank.name
                  ? item.bank.name
                  : $t("haveNot") + " - " + item.bank.number
                : item.bank.name
                ? item.bank.name
                : $t("haveNot") + " - " + $t("haveNot")
              : ""
          }}
          {{
            item.type === "customer"
              ? item.bank_account_number
                ? item.bank_name
                  ? item.bank_name
                  : $t("haveNot") + " - " + item.bank_account_number
                : item.bank_name
                ? item.bank_name
                : $t("haveNot") + " - " + $t("haveNot")
              : " "
          }}
        </template>
        <template v-slot:item.kind="{ item }">
          <!-- {{ item.type == "own" ? $t("normal") : $t(item.kind) }} -->
          {{ $t(item.kind) }}
        </template>
        <template v-slot:item.owner_name="{ item }">
          {{ item.owner_name || " - " }}
        </template>
        <template v-slot:item.relations="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(relation, index) in item.relations"
              :key="index"
              :color="relation.color"
              label
              outlined
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              {{ relation.name }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.status.status="{ item }">
          <v-chip
            v-if="item.status && item.status.status"
            :color="item.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
            @click="openCheckStatusDialog(item)"
          >
            <span class="px-2 white--text">
              {{ $t(item.status.status) }}
              {{
                item.status.status === "fund" && item.cashbox
                  ? "&nbsp;" + item.cashbox.name + ""
                  : ""
              }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.payed_account_id && item.type == 'customer'"
            color="primary"
            label
            small
            style="cursor: pointer"
            class="px-1 ma-1"
          >
            <span class="px-2 white--text">
              {{ $t("to") }} {{ $t(item.payed_account.name) }} - {{ $t("date") }}:{{
                item.payed_date
              }}
            </span>
          </v-chip>
          <v-chip
            v-if="type == 'payCheck' && item.type == 'customer'"
            color="teal"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("recieveCheck") }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.initial_period"
            color="primary"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("initialPeriod") }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.status && item.status.bank"
            color="green"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ item.status.bank.name }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.status && item.status.bank"
            color="orange"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("lastChangeStatus") }} : {{ item.status.time }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:body.append>
          <tr>
            <td :colspan="`${isMobile ? 6 : Number(showHeaders.length)}`">
              <div style="width: 100%" class="pa-1">
                <strong>{{ $t("sumInPage") }}</strong
                >:
                <v-chip color="primary" class="px-1">
                  <span class="px-1 white--text">
                    {{ $numberFormat(totals.sum) }}
                  </span>
                </v-chip>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      v-model="checkStatusDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="checkStatusDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("status") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <checkStatus v-model="lastStatus" :check-item="checkItem" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <div style="position: fixed; z-index: 2">
            <v-btn icon color="grey darken-2" @click="printDialog = false">
              <v-icon class="close-hover" large> mdi-close </v-icon>
            </v-btn>
          </div>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :turnover-prop="totals"
            :from-date="fromDate"
            :to-date="toDate"
            :title="$t('list') + ' ' + $t(type)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <autocomplete
              v-model="account"
              :title="type == 'payCheck' ? $t('reciever') : $t('payer')"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col v-if="type == 'payCheck'" cols="12" md="4">
            <autocomplete
              v-model="bank"
              :title="$t('bank')"
              type="bank"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col v-if="type == 'recieveCheck'" cols="12" md="4">
            <autocomplete
              v-model="bankRecieve"
              :title="$t('bank')"
              type="bankCheckRecieve"
              :filter="false"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="currencyFilter"
              :title="$t('currency')"
              type="currency"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('dueDate')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('dueDate')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="status"
              :label="$t('status')"
              :items="statusItems"
              height="30"
              dense
              outlined
              multiple
              clearable
              item-value="value"
              item-text="text"
              item-disabled="disable"
            />
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip v-if="index === 1" small>
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t("other") }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="lockStatus"
              :label="$t('lockStatusDocuments')"
              :items="lockStatusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col v-if="type == 'recieveCheck'" cols="12" md="4">
            <autocomplete
              v-model="cashBox"
              :title="$t('cashBox')"
              type="getCash"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col cols="6" class="pa-0 py-1">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="pa-0 py-1">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="documentPrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="documentPrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <documentPrint :id-prop="documentId" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--checkAverageDialog-->
    <v-dialog
      v-model="checkAverageDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="600"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-1">{{ $t("check-list") }}</v-card-text>
          <v-icon size="15" @click="checkAverageDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-space-between align-end my-6">
          <div>
            <v-card-text class="pa-0 text-body-2">
              {{ $t("count") }} : {{ selectedCheck ? selectedCheck.length : "" }}
              {{ $t("numbers") }}
            </v-card-text>
            <v-card-text class="pa-0 text-body-2 mt-1">
              {{ $t("sumAmount") }} : {{ checksTotal ? $numberFormat(checksTotal) : 0 }}
              {{ $t("rial") }}
            </v-card-text>
            <v-card-text class="pa-0 text-body-1 mt-1">
              {{ $t("checks-count") }} :
              {{
                checkAverageDate ? checkAverageDate.split("T")[0].replace(/-/g, "/") : ""
              }}
            </v-card-text>
          </div>
          <div class="d-flex justify-end flex-column">
            <v-btn
              color="primary"
              height="32"
              class="mb-4 mr-12"
              :loading="loading"
              @click="fetchCheckAverageSecond"
            >
              {{ $t("check-head-recalculation") }}
            </v-btn>
            <template>
              <v-text-field
                id="selectedDate"
                v-model="selectedDate"
                :label="$t('date')"
                append-icon="mdi-calendar"
                :rules="[(v) => !!v || $t('is-required')]"
                outlined
                dense
                clearable
                :class="{ 'mt-5': isMobile }"
              />
              <date-picker
                v-model="selectedDate"
                element="selectedDate"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :min="$store.state.startDate"
                :max="$store.state.endDate"
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </div>
        </v-container>
        <v-data-table
          :headers="checkAverageHeaders"
          :items="checkAverageItems"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          style="background-color: #eeeeee"
          fixed-header
          class="checkAverage"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">
              {{ index + 1 }}
            </v-card-text>
          </template>
          <template v-slot:item.checkNumber="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.number ? item.number : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.detailsInvoice="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.account ? item.account.name : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.dueDate="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.due_date ? item.due_date : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.amount="{ item }">
            <v-card-text v-if="item.amount" class="pa-0 text-caption">
              {{ $numberFormat(item.amount) }} {{ item.currency.name }}
            </v-card-text>
            <v-card-text v-else class="pa-0 text-caption">
              {{ $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.bank="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.bank_name ? item.bank_name : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:header.edit="{ header }">
            <div @click="openCheckDeleteDialog('all')">
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :cursor-pointer="true"
              />
            </div>
          </template>
          <template v-slot:item.edit="{ item, index }">
            <div @click="openCheckDeleteDialog('single', item.id)">
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :cursor-pointer="true"
              />
            </div>
          </template>
        </v-data-table>
        <v-card-text
          v-if="isThereInvoiceWithoutId"
          class="pa-0 text-body-2 mt-1"
          style="color: #ff5252"
        >
          {{ $t("only checks with due-date can be calculated") }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--delete dialog-->
    <v-dialog
      v-model="checkDeleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">
          {{
            deleteAllCheck
              ? $t("are you sure you want to delete all items?")
              : $t("Are you sure you want to delete this item ?")
          }}
        </v-card-text>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn color="error" height="32" @click="deleteCheck">
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            height="32"
            color="secondary"
            @click="checkDeleteDialog = false"
          >
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="recieveCheck"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import Task from "../task/task";
import Upload from "../../components/general/upload/upload";
import General from "../../../../Mixins/general";
import checkStatus from "./checkStatus";
import documentPrint from "../accounting/print";
import dialogComponent from "../../components/general/dialog/index";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import moment from "moment-jalaali";
import { numberFormat } from "highcharts";

export default {
  name: "CheckList",
  components: {
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Tag: () => import("../../components/general/Tag/tag"),
    documentPrint,
    checkStatus,
    dialogComponent,
    Task,
    MyIcon,
    Upload,
  },
  mixins: [General],
  props: ["input", "refId", "typeProp", "mobileShow", "statusProp", "titleProp"],
  data: () => ({
    excelItems: [],
    printHeaders: [],
    selected: [],
    pageCount: 1,
    page: 1,
    printDialog: false,
    cashBox: null,
    registerar: null,
    removedChecks: null,
    summary: null,
    bankRecieve: null,
    account: null,
    bank: null,
    currencyFilter: null,
    deletDialog: false,
    uploadDialog: false,
    documentPrintDialog: false,
    checkStatusDialog: false,
    showSelect: true,
    filter: false,
    dialogData: null,
    statusItems: [],
    documentId: null,
    checkItem: null,
    fromDate: null,
    toDate: null,
    lastStatus: null,
    lastStatusItemIndex: null,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    status: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    snakbarColor: null,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    selectedHeaders: [],
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    selectedCheck: [],
    checkAverageDialog: false,
    selectedDate: null,
    today: null,
    checkAverageItems: null,
    checkDeleteDialog: false,
    deleteAllCheck: false,
    selectedCheckID: null,
    checksID: [],
    checksTotal: 0,
    checkAverageDate: null,
    invoice_without_due_date: null,
    isThereInvoiceWithoutId: false,
  }),
  computed: {
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        return app.selectedHeaders.includes(s);
      });
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    totals: function () {
      const totals = this.items.reduce(
        (acc, d) => {
          acc.sum += parseFloat(d.amount);
          return acc;
        },
        {
          sum: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    type() {
      if (this.mobileShow) {
        if (this.type === "payCheck") {
          this.status = ["issued"];
        } else {
          this.status = ["fund"];
        }
      }
      this.getItems();
    },
    lastStatus() {
      this.items[this.lastStatusItemIndex].status = this.lastStatus;
      this.checkStatusDialog = false;
    },
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      const validItems = this.selected.filter((item) => item.due_date != null);
      this.selectedCheck = validItems;
      this.invoice_without_due_date = this.selected.filter(
        (item) => item.due_date == null
      );

      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    checkAverageDialog(val) {
      if (val) {
        this.selectedDate = this.today;
        this.checkAverageItems = this.selectedCheck;
      }
    },
    checkAverageItems(val) {
      this.selected = val;
      this.resolveChecksTotal();
    },
  },
  activated() {
    this.getItems();
  },
  beforeMount() {
    this.statusItems = [
      {
        value: "fund",
        text: this.$t("fund"),
      },
      {
        value: "issued",
        text: this.$t("issued"),
      },
      {
        value: "returned",
        text: this.$t("returned"),
      },
      {
        value: "passed",
        text: this.$t("passed"),
      },
      {
        value: "bank",
        text: this.$t("inBank"),
      },
      {
        value: "payed",
        text: this.$t("payed"),
      },
      {
        value: "canceled",
        text: this.$t("canceled"),
      },
    ];
    if (this.$route.name === "payCheckList") {
      this.type = "payCheck";
    }
    if (this.$route.name === "recieveCheckList") {
      this.type = "recieveCheck";
    }
    if (this.$route.name === "removedChecks") {
      this.type = "removedChecks";
      this.removedChecks = "active";
    }
    if (this.typeProp) {
      this.type = this.typeProp;
    }
    if (this.statusProp) {
      this.status = [this.statusProp];
    }
    this.headers = [
      {
        text: this.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("id"),
        sortable: true,
        value: "id",
        table: "checks.id",
      },
      {
        text: this.$t("number") + " " + this.$t("document"),
        sortable: false,
        value: "doc_header.number",
      },
      {
        text: this.$t("name") + " " + this.$t("account"),
        sortable: false,
        value: "account.name",
      },
      {
        text: this.$t("number") + " " + this.$t("check"),
        sortable: false,
        value: "number",
      },
      {
        text: this.$t("bank"),
        sortable: false,
        value: "bank",
      },
      {
        text: this.$t("kind"),
        sortable: false,
        value: "kind",
      },
      {
        text: this.$t("date"),
        sortable: true,
        value: "date",
        table: "checks.date",
      },
      {
        text: this.$t("dueDate"),
        sortable: true,
        value: "due_date",
        table: "checks.due_date",
      },
      {
        text: this.$t("check_owner_name"),
        sortable: false,
        value: "owner_name",
      },
      {
        text: this.$t("fishermanNumber"),
        sortable: true,
        value: "fisherman_number",
        table: "checks.fisherman_number",
      },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "branch.name",
      },
      {
        text: this.$t("amount"),
        sortable: false,
        width: 100,
        value: "amount",
      },
      {
        text: this.$t("currency"),
        sortable: false,
        value: "currency",
      },
      {
        text: this.$t("status"),
        sortable: true,
        value: "status.status",
        table: "checks_status.status",
      },
      {
        text: this.$t("relations"),
        sortable: false,
        value: "relations",
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
      },
      {
        text: this.$t("content"),
        sortable: false,
        value: "content",
        table: "bank_cash.content",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.printHeaders = [
      {
        text: this.$t("id"),
        value: "id",
      },
      {
        text: this.$t("number") + " " + this.$t("document"),
        value: "doc_header",
      },
      {
        text: this.$t("name") + " " + this.$t("account"),
        value: "account",
      },
      {
        text: this.$t("number") + " " + this.$t("check"),
        value: "number",
      },
      {
        text: this.$t("bank"),
        value: "bank_name",
      },
      {
        text: this.$t("kind"),
        value: "kind",
        type: "translate",
      },
      {
        text: this.$t("date"),
        value: "date",
      },
      {
        text: this.$t("dueDate"),
        value: "due_date",
        width: 15,
      },
      {
        text: this.$t("check_owner_name"),
        value: "owner_name",
        width: 10,
      },
      {
        text: this.$t("status"),
        value: "lastStatus",
      },
      {
        text: this.$t("amount"),
        width: 10,
        type: "number",
        value: "amount",
        sum: true,
      },
    ];
    if (this.$route.params.id != null) {
      this.show();
      this.id = this.$route.params.id;
      this.render = false;
    }
    this.selectedHeaders = this.headers;
    this.checkAverageHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 25,
      },
      {
        text: this.$t("check-number"),
        align: "start",
        sortable: false,
        value: "checkNumber",
      },
      {
        text: this.$t("detailsInvoice"),
        align: "start",
        sortable: false,
        value: "detailsInvoice",
      },
      {
        text: this.$t("dueDate"),
        align: "start",
        sortable: false,
        value: "dueDate",
      },
      {
        text: this.$t("amount"),
        align: "start",
        sortable: false,
        value: "amount",
      },
      {
        text: this.$t("bank"),
        align: "start",
        sortable: false,
        value: "bank",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
      },
    ];
  },
  mounted() {
    this.setToday();
    if (this.input) {
      this.model = this.input;
    }
    this.getItems();
  },
  methods: {
    openUploadDialog() {
      this.uploadDialog = true;
    },
    setToday() {
      var m = moment();
      if (this.$store.state.date_locale === "fa,en") {
        const shamsiYear = m.jYear();
        const shamsiMonth = String(m.jMonth() + 1).padStart(2, "0");
        const shamsiDay = String(m.jDate()).padStart(2, "0");
        this.today = `${shamsiYear}/${shamsiMonth}/${shamsiDay}`;
      }
      if (this.$store.state.date_locale === "en,fa") {
        this.today = m.format("YYYY/MM/DD");
      }
    },
    openComponent(component, id) {
      this.dialogData = {
        name: component,
        id: id,
      };
      this.innerComponent = true;
    },
    documentPrint(item) {
      this.documentId = item.doc_head_id;
      this.documentPrintDialog = true;
    },
    openCheckStatusDialog(item) {
      this.checkItem = item;
      this.checkStatusDialog = true;
      this.lastStatusItemIndex = this.items.indexOf(item);
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      if (item.lock) {
        return false;
      }
      if (!this.removedChecks) {
        this.$router.push({ name: this.type + "Edit", params: { id: item.id } });
      }
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      var bankRecieve = [];
      if (app.bankRecieve) {
        app.bankRecieve.map(function (val, index) {
          bankRecieve.push(val.name);
        });
      }
      app.$axios
        .get(this.$endpoint + "checks", {
          params: {
            account: app.account,
            bank: app.bank,
            bankRecieve: bankRecieve,
            from: app.fromDate,
            to: app.toDate,
            currencyFilter: app.currencyFilter,
            branch: app.branch,
            search: app.search,
            page: app.allRows ? app.excelPage : app.options.page,
            refId: app.refId,
            lockStatus: app.lockStatus,
            type: app.type,
            cashBox: app.cashBox,
            sortBy: app.sortBy,
            status: app.status,
            options: app.options,
            tag: app.tag,
            registerar: app.registerar,
            typeForm: app.typeForm,
            removedChecks: app.removedChecks,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.summary = res.summary;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "checks/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .delete(this.$endpoint + "checks/0", {
          params: { deleteItems: selected },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    lock(item, type) {
      if (this.$store.state.userCurrentPlan != null) {
        const lockItem = this.$store.state.userCurrentPlan.plan.options.find(
          (item) => item.key == "lockSystem"
        );
        if (lockItem && lockItem.value == "deactive") {
          this.$store.commit("SET_PLAN_DIALOG", true);
          this.$router.replace("/");
        } else {
          this.selected = [item];
          this.lockGroup(type);
        }
      }
    },
    // add unlock group send type
    unlockGroup(type = "unlock") {
      this.lockGroup(type);
    },
    lockGroup(type) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "checks", {
          params: {
            lock: "active",
            id: selected,
            type: type,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarText = this.$t("opertationSuccess");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    refreshRemovedItem() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "checks", {
          params: {
            refreshRemovedChecks: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          id: d.id,
          number: d.number,
          accountId: d.account_id,
          bank:
            d.type === "own"
              ? d.bank.name + "-" + d.bank.number
              : d.type === "customer"
              ? d.bank_name + "-" + d.bank_account_number
              : "",
          amount: d.amount,
          date: d.date,
          check_owner_name: d.owner_name || "",
          content: d.content,
          fishermanNumber: d.fisherman_number,
          dueDate: d.due_date,
          documentNumber: d.doc_header ? d.doc_header.number : "",
          account: d.account ? d.account.name : "",
          user: d.user ? d.user.name : "",
        });
      });
    },
    openCheckDeleteDialog(select, checkId) {
      this.checkDeleteDialog = true;
      if (select == "all") {
        this.deleteAllCheck = true;
      } else {
        this.deleteAllCheck = false;
        this.selectedCheckID = checkId;
      }
    },
    deleteCheck() {
      if (this.deleteAllCheck) {
        this.checkAverageItems = [];
        this.selected = [];
      } else {
        const selectedCheckIndexTable = this.checkAverageItems.findIndex(
          (item) => item.id == this.selectedCheckID
        );
        this.checkAverageItems.splice(selectedCheckIndexTable, 1);
      }
      this.checkDeleteDialog = false;
    },
    fetchCheckAverageFirst() {
      if (this.selectedCheck && this.selectedCheck.length == 0) {
        this.snakbarText =
          this.$t("first add some items from list") +
          "(" +
          this.$t("only checks with due-date can be calculated") +
          ")";
        this.snakbarColor = "red";
        this.snakbar = true;
      }

      if (this.invoice_without_due_date && this.invoice_without_due_date.length > 0) {
        this.isThereInvoiceWithoutId = true;
      }

      /* if (this.invoice_without_due_date != null) {
          const invoiceID_without_due_date = this.invoice_without_due_date.map(item => item.id)

          if (invoiceID_without_due_date.length > 0) {
            this.snakbarText = `${this.$t("selected item doesn't have due date")} : ${invoiceID_without_due_date.join(', ')}`
            this.snakbarColor = 'red'
            this.snakbar = true
          }
        } */

      this.selectedCheck.forEach((item) => {
        this.checksID.push(item.id);
      });
      if (this.checksID.length > 0) {
        var app = this;
        this.loading = true;
        app.$axios
          .post(app.$endpoint + "duedateInvoice/check", {
            ids: this.checksID,
            base_date: moment(this.today, "jYYYY/jM/jD").format("YYYY-MM-DD"),
          })
          .then((r) => {
            if (r.data) {
              this.checkAverageDate = r.data.due_date;

              if (this.checkAverageDate) {
                this.checkAverageDialog = true;
              }
              this.checksID = [];
              this.loading = false;
            }
          })
          .catch((err) => {
            if (
              err.response &&
              (err.response.status == 422 || err.response.status == 403)
            ) {
              this.snakbarText = this.$t("can't change to lower plan");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
            this.serverErrorHandeler(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    fetchCheckAverageSecond() {
      this.loading = true;
      this.checkAverageItems.forEach((item) => {
        this.checksID.push(item.id);
      });
      if (this.checksID.length > 0) {
        var app = this;
        app.$axios
          .post(app.$endpoint + "duedateInvoice/check", {
            ids: this.checksID,
            base_date: moment(this.selectedDate, "jYYYY/jM/jD").format("YYYY-MM-DD"),
          })
          .then((r) => {
            if (r.data) {
              this.checkAverageDate = r.data.due_date;
              this.checksID = [];
              this.loading = false;
            }
          })
          .catch((err) => {
            if (
              err.response &&
              (err.response.status == 422 || err.response.status == 403)
            ) {
              this.snakbarText = this.$t("can't change to lower plan");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
            this.serverErrorHandeler(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resolveChecksTotal() {
      this.checksTotal = this.checkAverageItems.reduce((sum, item) => {
        return sum + Number(item.amount);
      }, 0);
    },
  },
};
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-data-table.checkAverage .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.checkAverage {
  border: 1px solid silver;
  /*  border-bottom: 0;
   border-bottom-right-radius: 0;
   border-bottom-left-radius: 0; */
  /* height: 300px;
  overflow-y: auto; */
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
/* ::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table {
  height: 100%;
} */
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver;
  padding: 0 9px;
  color: black;
  height: 40px !important;
  background-color: #eeeeee;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
</style>
